import React, { Component } from "react";
import axios from 'axios';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEdit, faTrash} from "@fortawesome/free-solid-svg-icons";
import Swal from 'sweetalert2';
import {Link} from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import 'bootstrap/dist/css/bootstrap.min.css';

export default class CountryList extends Component {

    state={
        countries:[],
    }
    componentDidMount(){
        axios.get('https://arianaapp.arianaapply.com/panel/get-country')
        .then(res=>{
            console.log(res)
            this.setState({countries: res.data})
        }).catch(err=>{
            console.log(err)
        })
    }

    deleteHandler(id){
        axios.get(`https://arianaapp.arianaapply.com/panel/delete-country/${id}`)
        .then(res=>{
            console.log(res)
            Swal.fire({
                title: 'با موفقیت حذف شد',
                icon: 'success'
            }).then(()=>{
              window.location.reload();
            })

        }).catch(err=>{
            console.log(err)
        })
    }


  render() {
      const {countries} = this.state;
    return (
      <div className="index">
       {
         countries.length > 0 ?
         <div className="table">
         <table>
           <thead>
             <tr>
              <td>#</td>
               <td>کشور</td>
               <td>قاره</td>
               <td>عملیات</td>
             </tr>
           </thead>
           <tbody>
               {
                   countries.map((item , i)=>(
                       <tr key={item._id}>
                        <td>{i}</td>
                       <td>{item.country}</td>
                       <td>{item.continent}</td>
                       <td>
                         <div className="d-flex">
                           <Link to={`/country-edit/${item._id}`}>
                           <button className="success">
                             <FontAwesomeIcon icon={faEdit} />
                           </button>
                           </Link>
                     
                           <button className="danger" onClick={()=> this.deleteHandler(item._id)}>
                             <FontAwesomeIcon icon={faTrash} />
                           </button>
                         </div>
                       </td>
                     </tr>
                   ))
               }

           </tbody>
         </table>
       </div> : <Spinner animation="border" variant="primary" />
       }
      </div>
    );
  }
}
